import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FcElectronics } from "react-icons/fc";
import { LazyImageComponent } from "../../../CustomComponent/lazy_loading_image";
import { useSelector } from "react-redux";

const getBadge = (status) => {
  switch (status) {
    case "available":
      return <span className="badge bg-green text-green-fg">Available</span>;
    case "pending":
      return (
        <span className="badge bg-yellow text-yellow-fg">Pending Approval</span>
      );
    case "assigned":
      return <span className="badge bg-blue text-blue-fg">Assigned</span>;
    default:
      return <span className="badge bg-gray text-gray-fg">{status}</span>;
  }
};
const ViewCompanyAssets = () => {
  const [data, setData] = useState();
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const store = useSelector((store) => store.login.user);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/companyassets/getassetsById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting details!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id, refresh]);

  const handelModelOpen = (status) => {
    // setDeleteSalaryAdjustId(id);
    if (status === "assigned") {
      document.getElementById("open-modal-assign").click();
    } else {
      document.getElementById("open-modal-return").click();
    }
  };

  const AssignStatus = (status) => {
    let formdata = new FormData();
    formdata.append("status", status);
    formdata.append("statusUpdate", true);
    performRequest("PATCH", `/companyassets/updateassets/${id}`, formdata, {
      contentType: "multipart/form-data",
    })
      .then((res) => {
        if (res.status === 200) {
          document.getElementById("modal-close").click();
          Toast("success", "Assign details updated successfully!");
          setRefresh(!refresh);
        } else {
          document.getElementById("modal-close").click();
          Toast("error", "Error while updating.");
        }
      })
      .catch((err) => {
        document.getElementById("modal-close").click();
        CustomErrorResponse(err);
      });
  };

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">
                  <FcElectronics></FcElectronics> View Assets
                </h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header row g-2 align-items-center">
              <div className="col">
                <h2>View Assets</h2>
              </div>
              <div className="col-auto ms-auto d-print-none"></div>
            </div>
            <div className="card-body">
              {data && (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Photo</label>
                    <div className="w-100 col">
                      <LazyImageComponent
                        src={data?.photo}
                        alt="asset image"
                        width={"60%"}
                      />
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Name</label>
                    <div className="w-100 col">
                      {(data?.name || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Asset Id</label>
                    <div className="w-100 col">
                      {(data?.assetId || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Price</label>
                    <div className="w-100 col">{data?.price || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Description</label>
                    <div className="w-100 col">
                      {(data?.description || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Current assignTo
                    </label>
                    <div className="w-100 col">
                      {(data?.assignToName || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Assign date</label>
                    <div className="w-100 col">{data?.assignDate || "N/A"}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3" id="modal-close">
                      Status
                    </label>
                    <div className="w-100 col">{getBadge(data?.status)}</div>
                  </div>
                  {data?.assignHistory && data?.assignHistory.length > 0 && (
                    <div>
                      <hr />
                      <h3>Assign History</h3>
                      <table className="table table-vcenter">
                        <thead>
                          <tr>
                            <th>assign to</th>
                            <th>assign date</th>
                            <th>handover date</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.assignHistory.map((item, index) => (
                            <tr key={index}>
                              <td>{item?.assignToName || "N/A"}</td>
                              <td>{item?.assignDate || "N/A"}</td>
                              <td>{item?.handOverDate || "In Use"}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                {data?.status === "pending" &&
                  store.Role === process.env.REACT_APP_ROLE_ADMIN_S && (
                    <button
                      onClick={() => handelModelOpen("assigned")}
                      className="btn mx-1 mt-2 btn-danger"
                    >
                      Approve & Assign
                    </button>
                  )}
                {data?.status === "assigned" && (
                  <button
                    onClick={() => handelModelOpen("available")}
                    className="btn mx-1 mt-2 btn-danger"
                  >
                    Mark as Returned
                  </button>
                )}
                <SimpleButton
                  buttonText="Edit Assets"
                  onClick={() => navigate(`/company-assets/edit/${id}`)}
                />
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-danger1"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <span
                id="open-modal-assign"
                data-bs-toggle="modal"
                data-bs-target="#modal-danger1"
              ></span>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-status bg-warning"></div>
              <div className="modal-body text-center py-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon mb-2 text-warning icon-lg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z" />
                  <path d="M12 9v4" />
                  <path d="M12 17h.01" />
                </svg>
                <h3>Are you sure about assigning this asset?</h3>
                <div className="text-muted">
                  Do you really want to assign this asset to the employee? This
                  action will be recorded.
                </div>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn w-100" data-bs-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                    <div className="col">
                      <button
                        className="btn btn-danger w-100"
                        data-bs-dismiss="modal"
                        onClick={() => AssignStatus("assigned")}
                      >
                        Approve & Assign
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="modal modal-blur fade"
          id="modal-danger2"
          tabIndex="-1"
          role="dialog"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-sm modal-dialog-centered"
            role="document"
          >
            <div className="modal-content">
              <span
                id="open-modal-return"
                data-bs-toggle="modal"
                data-bs-target="#modal-danger2"
              ></span>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
              <div className="modal-status bg-warning"></div>
              <div className="modal-body text-center py-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="icon mb-2 text-warning icon-lg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  strokeWidth="2"
                  stroke="currentColor"
                  fill="none"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M10.24 3.957l-8.422 14.06a1.989 1.989 0 0 0 1.7 2.983h16.845a1.989 1.989 0 0 0 1.7 -2.983l-8.423 -14.06a1.989 1.989 0 0 0 -3.4 0z" />
                  <path d="M12 9v4" />
                  <path d="M12 17h.01" />
                </svg>
                <h3>Are you sure about returning this asset?</h3>
                <div className="text-muted">
                  Do you really want to mark this asset as returned? This action
                  will update the assignment record.
                </div>
              </div>
              <div className="modal-footer">
                <div className="w-100">
                  <div className="row">
                    <div className="col">
                      <button className="btn w-100" data-bs-dismiss="modal">
                        Cancel
                      </button>
                    </div>
                    <div className="col">
                      <button
                        className="btn btn-danger w-100"
                        data-bs-dismiss="modal"
                        onClick={() => AssignStatus("available")}
                      >
                        Mark as Returned
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewCompanyAssets;
